export const dartKey = {
  getDarts: () => ['darts'] as const,
  getRewardStatus: () => ['dart', 'reward-status'] as const,
  getSurveyLink: () => ['dart', 'survey-link'] as const,
  getDailyReward: () => ['dart', 'daily-reward'] as const,
  getSurveyReward: () => ['dart', 'survey-reward'] as const,
} as const;

export default dartKey;
